import { useEffect } from 'react';

/**
 * Enforces `aria-invalid` on a DOM element, re-applying it whenever an
 * external library (e.g. MUI) resets the attribute.
 */
export const useAriaInvalid = (
  getElement: () => HTMLElement | null | undefined,
  error: unknown,
  deps: React.DependencyList = [],
) => {
  useEffect(() => {
    const el = getElement();
    if (!el) return;

    const expectedValue = error ? 'true' : 'false';
    el.setAttribute('aria-invalid', expectedValue);

    const observer = new MutationObserver(() => {
      el.setAttribute('aria-invalid', expectedValue);
    });

    observer.observe(el, { attributes: true, attributeFilter: ['aria-invalid'] });

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, ...deps]);
};
